export default {
  // 基础框架
  '@/components/main': import('@/components/main'),
  '@/components/parent-view': import('@/components/parent-view'),
  // 系统管理
  '@/view/system/function': import('@/view/system/function'),
  '@/view/system/role': import('@/view/system/role'),
  '@/view/system/user': import('@/view/system/user'),
  '@/view/system/log': import('@/view/system/log'),
  '@/view/system/setting': import('@/view/system/setting'),
  '@/view/system/setting/add': import('@/view/system/setting/add'),
  '@/view/system/setting/edit': import('@/view/system/setting/edit'),
  '@/view/system/dictionary': import('@/view/system/dictionary'),

  // 个人信息
  '@/view/single-page/profile': import('@/view/single-page/profile/index.vue'),
  // 会员管理
  '@/view/member/audit': import('@/view/member/audit'),
  '@/view/member/audit/detail': import('@/view/member/audit/detail'),
  // 专家库-随机抽取
  '@/view/expert': import('@/view/expert/index.vue'),
  '@/view/expert/detail': import('@/view/expert/detail.vue'),
  // 专家库-随机抽取
  '@/view/lottery': import('@/view/lottery/index.vue'),
  '@/view/lottery/manager': import('@/view/lottery/manager.vue'),
  '@/view/lottery/detail': import('@/view/lottery/detail.vue'),
  '@/view/lottery/randongen': import('@/view/lottery/randomgen.vue'),

  // 会员管理
  '@/view/member/quit': import('@/view/member/quit'),
  '@/view/member/initiation': import('@/view/member/initiation'),
  '@/view/member/initiation/components/detail': import('@/view/member/initiation/components/detail'),
  '@/view/member/change/list': import('@/view/member/change/list'),
  '@/view/member/change/info': import('@/view/member/change/info'),
  '@/view/member/list': import('@/view/member/list'),
  '@/view/member/register': import('@/view/member/register'),
  '@/view/member/stastic': import('@/view/member/stastic'),
  // 会费管理
  '@/view/membership-fee/audit': import('@/view/membership-fee/audit'),
  '@/view/membership-fee/audit/detail': import('@/view/membership-fee/audit/detail'),
  '@/view/membership-fee/audit/offline_top_up': import('@/view/membership-fee/audit/offline_top_up'),
  '@/view/membership-fee/detail': import('@/view/membership-fee/detail'),
  '@/view/membership-fee/detail/transcation-flow': import('@/view/membership-fee/detail/transcation-flow'),
  '@/view/membership-fee/remind': import('@/view/membership-fee/remind'),
  '@/view/membership-fee/stats': import('@/view/membership-fee/stats'),
  '@/view/membership-fee/payment': import('@/view/membership-fee/payment'),
  // QC申报系统
  '@/view/psm/qc/list': import('@/view/psm/qc'),
  '@/view/psm/qc/config': import('@/view/psm/qc/config'),
  '@/view/psm/qc/voucher': import('@/view/psm/qc/voucher'),
  '@/view/psm/qc/group_detail': import('@/view/psm/qc/group_detail'),
  '@/view/psm/qc/voucher_detail': import('@/view/psm/qc/voucher_detail'),
  '@/view/psm/qc/history': import('@/view/psm/qc/history'),
  '@/view/psm/qc/export': import('@/view/psm/qc/export'),
  // 绿色工程申报
  '@/view/psm/gdp/list': import('@/view/psm/gdp'),
  '@/view/psm/gdp/config': import('@/view/psm/gdp/config'),
  '@/view/psm/gdp/detail': import('@/view/psm/gdp/detail'),
  '@/view/psm/gdp/history': import('@/view/psm/gdp/history'),
  '@/view/psm/gdp/down_file': import('@/view/psm/gdp/down_file'),
  // 科技创新成果申报
  '@/view/psm/innovate/list': import('@/view/psm/innovate/list'),
  '@/view/psm/innovate/history': import('@/view/psm/innovate/history'),
  '@/view/psm/innovate/detail': import('@/view/psm/innovate/detail'),
  '@/view/psm/innovate/config': import('@/view/psm/innovate/configuration'),
  // 科技示范工程申报
  '@/view/psm/demonstration/list': import('@/view/psm/demonstration/list'),
  '@/view/psm/demonstration/history': import('@/view/psm/demonstration/history'),
  '@/view/psm/demonstration/detail': import('@/view/psm/demonstration/detail'),
  '@/view/psm/demonstration/config': import('@/view/psm/demonstration/configuration'),
  // 优秀建造师申报
  '@/view/psm/architect/list': import('@/view/psm/architect/list'),
  '@/view/psm/architect/history': import('@/view/psm/architect/history'),
  '@/view/psm/architect/detail': import('@/view/psm/architect/detail'),
  '@/view/psm/architect/config': import('@/view/psm/architect/configuration'),
  // 结构优质工程申报
  '@/view/psm/sp/add_config': import('@/view/psm/sp/add_config'),
  '@/view/psm/sp/list': import('@/view/psm/sp/list'),
  '@/view/psm/sp/config': import('@/view/psm/sp/config'),
  '@/view/psm/sp/detail': import('@/view/psm/sp/detail'),
  '@/view/psm/sp/history': import('@/view/psm/sp/history'),

  // 结构工程
  // '@/view/psm/hqp/list': import('@/view/psm/hqp/list'),
  // 证书管理
  '@/view/cert/generate': import('@/view/cert/generate'),
  '@/view/cert/generate/detail': import('@/view/cert/generate/detail.vue'),
  '@/view/cert/generate/create': import('@/view/cert/generate/create.vue'),
  '@/view/cert/generate/edit': import('@/view/cert/generate/edit.vue'),
  '@/view/cert/receive': import('@/view/cert/receive'),
  // 结构工程
  '@/view/psm/hqp/list': import('@/view/psm/hqp/list'),
  '@/view/psm/hqp/config': import('@/view/psm/hqp/config'),
  '@/view/psm/hqp/add_config': import('@/view/psm/hqp/add_config'),
  '@/view/psm/hqp/detail': import('@/view/psm/hqp/detail'),
  '@/view/psm/hqp/history': import('@/view/psm/hqp/history'),
  '@/view/psm/hqp/statistics': import('@/view/psm/hqp/statistics'),
  '@/view/psm/hqp/statistics/currentTable': import(
    '@/view/psm/hqp/statistics/currentTable'
  ), // 申报中数据统计表
  '@/view/psm/hqp/statistics/yearTable': import(
    '@/view/psm/hqp/statistics/yearTable'
  ), // 历史申报年度统计表
  // 科技成果
  '@/view/psm/tap/list': import('@/view/psm/tap'),
  '@/view/psm/tap/config': import('@/view/psm/tap/config'),
  '@/view/psm/tap/detail': import('@/view/psm/tap/detail'),
  '@/view/psm/tap/history': import('@/view/psm/tap/history'),
  // 内容管理
  '@/view/cms/gsa': import('@/view/cms/gsa'), // 协会概况
  '@/view/cms/gsa/detail': import('@/view/cms/gsa/detail.vue'), // 协会概况
  '@/view/cms/params': import('@/view/cms/params'), // 参数管理
  '@/view/cms/params/detail': import('@/view/cms/params/detail.vue'),
  '@/view/cms/news': import('@/view/cms/news'), // 新闻公告
  '@/view/cms/news/detail': import('@/view/cms/news/detail.vue'),
  '@/view/cms/job': import('@/view/cms/job'), // 协会工作
  '@/view/cms/job/detail': import('@/view/cms/job/detail.vue'),
  '@/view/cms/policy': import('@/view/cms/policy'), // 政策法规
  '@/view/cms/policy/detail': import('@/view/cms/policy/detail.vue'),
  '@/view/cms/member': import('@/view/cms/member'), // 会员之家
  '@/view/cms/member/detail': import('@/view/cms/member/detail.vue'),
  '@/view/cms/media': import('@/view/cms/media'), // 媒体焦距
  '@/view/cms/media/detail': import('@/view/cms/media/detail.vue'),
  '@/view/cms/media/detail-index': import('@/view/cms/media/detail-index.vue'),
  '@/view/cms/party_relation': import('@/view/cms/party-relation'), // 党群关系
  '@/view/cms/party_relation/detail': import('@/view/cms/party-relation/detail.vue'),
  '@/view/cms/branch': import('@/view/cms/branch'), // 分支机构
  '@/view/cms/branch/detail': import('@/view/cms/branch/detail.vue'),
  '@/view/cms/download': import('@/view/cms/data-download'), // 资料下载
  '@/view/cms/download/detail': import('@/view/cms/data-download/detail.vue'),
  '@/view/cms/product': import('@/view/cms/product/index.vue'), // 产业化分会
  '@/view/cms/product/detail': import('@/view/cms/product/detail.vue'),
  '@/view/cms/application': import('@/view/cms/application/index.vue'), // 网上申报
  '@/view/cms/application/detail': import('@/view/cms/application/detail.vue'),
  '@/view/cms/join': import('@/view/cms/join/index.vue'), // 加入我们
  '@/view/cms/join/detail': import('@/view/cms/join/detail.vue'),
  '@/view/cms/creat': import('@/view/cms/creat/index.vue'), // 创先争优
  '@/view/cms/creat/detail': import('@/view/cms/creat/detail.vue'),
  '@/view/cms/practice': import('@/view/cms/practice/index.vue'), // 行业培训
  '@/view/cms/practice/detail': import('@/view/cms/practice/detail.vue'),
  '@/view/cms/notice': import('@/view/cms/notice/index.vue'), // 通知公告
  '@/view/cms/notice/detail': import('@/view/cms/notice/detail.vue'),
  // 广告管理
  '@/view/ad/detail': import('@/view/ad/detail.vue'),
  '@/view/ad': import('@/view/ad'),
  // 业务管理
  '@/view/business/supply_demand': import('@/view/business/supply-demand'), // 供需对接
  '@/view/business/supply_demand/detail': import('@/view/business/supply-demand/detail'),	// 参数管理
  '@/view/param/manager/detail': import('@/view/param/manager/detail'),
  '@/view/business/review': import('@/view/business/review'), // 最新动态
  '@/view/business/review/detail': import('@/view/business/review/detail'),
  '@/view/business/feedback': import('@/view/business/feedback'), // 意见反馈
  '@/view/business/consultservice': import('@/view/business/consultservice'), // 我要咨询
  '@/view/business/mailbox': import('@/view/business/mailbox'), // 领导信箱
  // 会务管理
  '@/view/conference/add': import('@/view/conference/add'),
  '@/view/conference/list': import('@/view/conference/list'),
  '@/view/conference/detail': import('@/view/conference/detail'),
  '@/view/conference/sign-up': import('@/view/conference/sign-up'),
  // 班组资信评价管理
  '@/view/evaluation/configuration': import('@/view/evaluation/configuration'),
  '@/view/evaluation/infoTotal': import('@/view/evaluation/infoTotal'),
  '@/view/evaluation/declareList': import('@/view/evaluation/declareList'),
  '@/view/evaluation/declarelDetail': import('@/view/evaluation/declarelDetail'),
  '@/view/evaluation/evaluateDetail': import('@/view/evaluation/evaluateDetail'),

  // 省优秀建筑装饰工程奖申报
  '@/view/psm/ead/list': import('@/view/psm/ead/list'),
  '@/view/psm/ead/detail': import('@/view/psm/ead/detail'),
  '@/view/psm/ead/config': import('@/view/psm/ead/config'),
  '@/view/psm/ead/add_config': import('@/view/psm/ead/add_config'),
  '@/view/psm/ead/list/history': import('@/view/psm/ead/history'),

  // 百千万工程
  '@/view/millionsProject/projects': import('@/view/millionsProject/projects'),
  '@/view/millionsProject/projects/edit': import('@/view/millionsProject/projects/edit'),
  '@/view/millionsProject/enterprises': import('@/view/millionsProject/enterprises'),
  '@/view/millionsProject/enterprises/edit': import('@/view/millionsProject/enterprises/edit'),
  '@/view/millionsProject/cases': import('@/view/millionsProject/cases'),
  '@/view/millionsProject/cases/edit': import('@/view/millionsProject/cases/edit'),
  '@/view/millionsProject/policy': import('@/view/millionsProject/policy'),
  '@/view/millionsProject/policy/edit': import('@/view/millionsProject/policy/edit')
}



// WEBPACK FOOTER //
// ./src/router/mapping.js